/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TemplateFileType {
    SURVEY = 'survey',
    SURVEY_JOB_PROFILE = 'surveyJobProfile',
    MODULE_JOB = 'moduleJob',
    COMPANY_JOB = 'companyJob',
    COMPANY_JOB_LEVEL = 'companyJobLevel',
    COMPANY_JOB_FAMILY = 'companyJobFamily',
    EMPLOYEE_DATA = 'employeeData',
    SALARY_RANGE = 'salaryRange',
    JOB_MAPPING = 'jobMapping',
    BC_LEVEL_MAPPING = 'bcLevelMapping',
    MARKET_PRICE = 'marketPrice',
    CUT_REMOVAL = 'cutRemoval',
    PAYMARKET_LIST = 'paymarketList',
    CUSTOMER_FILE = 'customerFile',
    TEST_DATA = 'testData',
    SLOTTED_JOB = 'slottedJob',
    COMPOSITE_COMMENT = 'compositeComment',
    COMPOSITE_TAG = 'compositeTag',
    CURRENCY = 'currency',
    COMPANY_JOB_PAYMARKET_REWRITE = 'companyJobPaymarketRewrite',
    RANGE_GROUP_ELIGIBILITY = 'rangeGroupEligibility',
    RANGE_ZONE_ELIGIBILITY = 'rangeZoneEligibility',
    RANGE_NAME_ELIGIBILITY = 'rangeNameEligibility',
    RANGE_GUIDELINE = 'rangeGuideline',
    COMPANY_JOB_TAG = 'companyJobTag',
    SURVEY_JOB_MAPPING = 'surveyJobMapping',
    SURVEY_JOB_ROLLUP = 'surveyJobRollup',
    VENDOR_LEVEL_PROFILE = 'vendorLevelProfile',
    SURVEY_TENANT = 'surveyTenant',
    BULK_ENTITLEMENTS = 'bulkEntitlements',
}
